<template>
  <div>
	<div v-if="!json.init" class="spe-picture-complex-wrap"        
        :style="{
            backgroundColor: commonStyle && commonStyle.usePageBackgroundColor ? commonStyle.bgColor : commonStyle.backgroundColor,
            backgroundImage: commonStyle.backgroundType == 2 ? `url(${commonStyle.backgroundImage})` : ''
        }"
        :ddt-area="`component_${floorId}`"
        ddt-expose="on">
        <div class="spe-picture-complex" :style="{margin: `0px ${commonStyle.margin}px`}">
            <div class="left" style="margin-right: 0.18rem;">
                <template v-if="leftData.style==1">
                    <swiper class="swiper" :options="swiperLeftOptions">
                        <swiper-slide v-for="(item, i) in leftData.frameData" :key="i">
                            <a  @click="$sys.dict.href(item.jumpUrl)"
                                :data-area="pt()"
                                :data-pos="`component_${floorId}_复合图片组件.left图片点击跳转`"
                                :data-desc="item.image"
                                :dd_name="`${pt()}.component_${floorId}_复合图片组件.图片left_点击跳转.${item.image}`"
                                :ddt-click="`${pt()}.component_${floorId}_复合图片组件.图片lef_点击跳转.${item.image}`"
                                :ddt-pit="`图片left_点击跳转`"
                                :ddt-src="item.image"
                                ddt-expose="on">
                                <img v-lazy="item.image"/>
                            </a>
                        </swiper-slide>
                        <div v-if="leftData.frameData && leftData.frameData.length > 1" class="swiper-pagination" slot="pagination"></div>
                    </swiper>     
                </template>
                <template v-if="leftData.style==2">
                    <div class="top">
                        <a  @click="$sys.dict.href(leftData.pitData[0].jumpUrl)"
                            :data-area="pt()"
                            :data-pos="`component_${floorId}_复合图片组件.left-top图片点击跳转`"
                            :data-desc="leftData.pitData[0].image"
                            :dd_name="`${pt()}.component_${floorId}_复合图片组件.图片left-top_点击跳转.${leftData.pitData[0].image}`"
                            :ddt-click="`${pt()}.component_${floorId}_复合图片组件.图片left-top_点击跳转.${leftData.pitData[0].image}`"
                            :ddt-pit="`图片left-top_点击跳转`"
                            :ddt-src="leftData.pitData[0].image"
                            ddt-expose="on"
                        >
                            <img v-lazy="leftData.pitData[0].image"/>
                        </a>
                    </div>
                    <div class="bottom">
                        <a  @click="$sys.dict.href(leftData.pitData[1].jumpUrl)"
                            :data-area="pt()"
                            :data-pos="`component_${floorId}_复合图片组件.left-bottom图片点击跳转`"
                            :data-desc="leftData.pitData[1].image"
                            :dd_name="`${pt()}.component_${floorId}_复合图片组件.图片left-bottom_点击跳转.${leftData.pitData[1].image}`"
                            :ddt-click="`${pt()}.component_${floorId}_复合图片组件.图片left-bottom_点击跳转.${leftData.pitData[1].image}`"
                            :ddt-pit="`图片left-bottom_点击跳转`"
                            :ddt-src="leftData.pitData[1].image"
                            ddt-expose="on">
                            <img v-lazy="leftData.pitData[1].image"/>
                        </a>
                    </div>  
                </template>
            </div>
            <div class="right">
                <template v-if="rightData.style==1">
                    <swiper class="swiper" :options="swiperRightOptions">
                        <swiper-slide v-for="(item, i) in rightData.frameData" :key="i">
                            <a  @click="$sys.dict.href(item.jumpUrl)"
                                :data-area="pt()"
                                :data-pos="`component_${floorId}_复合图片组件.right图片点击跳转`"
                                :data-desc="item.image"
                                :dd_name="`${pt()}.component_${floorId}_复合图片组件.图片right_点击跳转.${item.image}`"
                                :ddt-click="`${pt()}.component_${floorId}_复合图片组件.图片right_点击跳转.${item.image}`"
                                :ddt-pit="`图片right_点击跳转`"
                                :ddt-src="item.image"
                                ddt-expose="on">
                                <img v-lazy="item.image"/>
                            </a>
                        </swiper-slide>
                        <div v-if="rightData.frameData && rightData.frameData.length > 1" class="swiper-pagination" slot="pagination"></div>
                    </swiper>     
                </template>
                <template v-if="rightData.style==2">
                    <div class="top">
                        <a  @click="$sys.dict.href(rightData.pitData[0].jumpUrl)"
                            :data-area="pt()"
                            :data-pos="`component_${floorId}_复合图片组件.right-top图片点击跳转`"
                            :data-desc="rightData.pitData[0].image"
                            :dd_name="`${pt()}.component_${floorId}_复合图片组件.图片right-top_点击跳转.${rightData.pitData[0].image}`"
                            :ddt-click="`${pt()}.component_${floorId}_复合图片组件.图片right-top_点击跳转.${rightData.pitData[0].image}`"
                            :ddt-pit="`图片right-top_点击跳转`"
                            :ddt-src="rightData.pitData[0].image"
                            ddt-expose="on">
                            <img v-lazy="rightData.pitData[0].image"/>
                        </a>
                    </div>
                    <div class="bottom">
                        <a  @click="$sys.dict.href(rightData.pitData[1].jumpUrl)"
                            :data-area="pt()"
                            :data-pos="`component_${floorId}_复合图片组件.right-bottom图片点击跳转`"
                            :data-desc="rightData.pitData[1].image"
                            :dd_name="`${pt()}.component_${floorId}_复合图片组件.图片right-bottom_点击跳转.${rightData.pitData[1].image}`"
                            :ddt-click="`${pt()}.component_${floorId}_复合图片组件.图片right-bottom_点击跳转.${rightData.pitData[1].image}`"
                            :ddt-pit="`图片right-bottom_点击跳转`"
                            :ddt-src="rightData.pitData[1].image"
                            ddt-expose="on"> 
                            <img v-lazy="rightData.pitData[1].image"/>
                        </a>
                    </div>  
                </template>
            </div>
        </div>
	</div>
  <div v-else :style="{height:`${json.height}px`}"></div>
	</div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
export default {
	props: {
		json: {
			type: Object,
			default: () => {
				return {};
			}
        }
	},
	components: {
		Swiper,
		SwiperSlide
	},
	data() {
		return {
            commonStyle: {},
            leftData: {},
            rightData: {},
            floorId: '',
            swiperLeftOptions: {},
            swiperRightOptions: {},
            swiperOptions: {
                slidesPerView: 1,
				loop: false,
                pagination: {
                    el: ".swiper-pagination",
                    type: "bullets"
                },
                observer: true, //修改swiper自己或子元素时，自动初始化swiper
                observeParents: true //修改swiper的父元素时，自动初始化swiper
            }
        };
	},
    inject: ['pt'],
	watch: {
        json :{
            handler(newVal, oldVal) {
                let { data, floorId } = newVal
                this.floorId = floorId
                this.commonStyle = data && data.commonStyle || {}
                this.rightData = data && data.right || {}
                this.leftData = data && data.left || {}
                this.swiperLeftOptions = Object.assign(this.swiperOptions, {
                    autoplay: {
                        delay: this.leftData.intervalTime * 1000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false
                    }
                })
                this.swiperRightOptions = Object.assign(this.swiperOptions, {
                    autoplay: {
                        delay: this.rightData.intervalTime * 1000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false
                    }
                })
            },
            deep: true,
            immediate: true
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.spe-picture-complex-wrap {
    width: 750px;
    padding: 20px 0px;
    .spe-picture-complex {
        display: flex;
        justify-content: center;
        flex: 1;
        .left, .right {
            max-width: 346px;
            max-height: 334px;
            border-radius: 16px;
            flex: 1;
            .swiper {
                flex: 1;
                height: 100%;
                width: 100%;
                border-radius: 16px;
                .swiper-slide {
                    width: 100% !important;
                    border-radius: 16px;
                }
                img {
                    flex: 1;
                    height: 100%;
                    width: 100%;
                    border-radius: 16px;
                }
                .swiper-pagination {
                    left: auto;
                    right: 20px;
                    bottom: 4px;
                    width: auto;
                    /deep/.swiper-pagination-bullet-active {
                        background: #ffffff;
                        border: 1px solid rgba(0, 0, 0, 0.17);
                    }
                }
                .swiper-pagination-fraction {
                    font-size: 20px;
                    color: #ffffff;
                    border-radius: 12px;
                    padding: 2px 12px;
                    background: rgba(1, 1, 1, 0.2);
                }
            }
            .top {
                width: 100%;
                max-height: 158px;
                border-radius: 16px;
                margin-bottom: 18px;
                flex: 1;
                img {
                    flex: 1;
                    width: 100%;
                    max-height: 158px;
                    border-radius: 16px;
                }
            }
            .bottom {
                width: 100%;
                max-height: 158px;
                border-radius: 16px;
                flex: 1;
                img {
                    flex: 1;
                    width: 100%;
                    max-height: 158px;
                    border-radius: 16px;
                }
            }
        }
    }
}
</style>
